import { config } from "../../config";

export const storage_keys = {
  QR_CODE: `${config.KEY_NAME}_QR_CODE`,
};
